const MENU = [
  {
    id: 'dashboard',
    icon: 'el-icon-s-grid',
    translationKey: 'general.news',
    routeName: 'DashboardPageRoute',
    subItems: [],
    hideOnDesktop: false,
  },
  {
    id: 'catalog',
    icon: 'el-icon-notebook-2',
    translationKey: 'menu.product_catalog',
    routeName: 'CatalogProductsPageRoute',
    subItems: [
      {
        id: 'catalog-products',
        icon: 'el-icon-tickets',
        translationKey: 'products.product',
        routeName: 'CatalogProductsPageRoute',
      },
      {
        id: 'catalog-systems',
        icon: 'el-icon-document',
        translationKey: 'systems.system',
        routeName: 'CatalogSystemsPageRoute',
      },
    ],
  },
  {
    id: 'mixer',
    icon: 'el-icon-set-up',
    translationKey: 'menu.mixer',
    routeName: 'ElasticMixerPageRoute',
    subItems: [
      {
        id: 'qcvmixer',
        icon: 'el-icon-set-up',
        translationKey: 'menu.qcvmixer',
        routeName: 'QCVMixerPageRoute',
      },
      {
        id: 'elaticmixer',
        icon: 'el-icon-set-up',
        translationKey: 'menu.elasticmixer',
        routeName: 'ElasticMixerPageRoute',
      },
    ],
  },
  {
    id: 'scanner',
    icon: 'el-icon-camera',
    translationKey: 'menu.scanner',
    routeName: 'QRScanPageRoute',
    subItems: [],
    hideOnDesktop: true,
  },
  {
    id: 'applications',
    icon: 'el-icon-brush',
    translationKey: 'menu.system_applications',
    routeName: 'SystemApplicationsPageRoute',
    subItems: [],
    hideOnDesktop: false,
  },
  {
    id: 'cart',
    icon: 'el-icon-shopping-cart-2',
    translationKey: 'menu.cart',
    routeName: 'CartOverviewPageRoute',
    subItems: [],
    hideOnDesktop: false,
  },
];

export default MENU;
